import React, { useState, useEffect } from 'react';
import Icon from '../../common/Icon';

const FieldsetDisplay = ({
  fieldset,
  isEditing,
  hasValidResponses,
  children,
}) => {
  const [expanded, setExpanded] = useState(hasValidResponses);
  const transitionStyle = {
    transition: 'max-height 0.5s ease-in-out',
    overflow: 'hidden',
    maxHeight: '0px',
  };

  const determineHeight = (elementId, showBool) => {
    let element = document.getElementById(elementId);
    if (element) {
      let height = element.scrollHeight;
      element.style.maxHeight = showBool ? `${height}px` : '0px';
    }
  };

  const handleClick = (e) => {
    e.preventDefault();
    setExpanded(!expanded);
  };

  useEffect(() => {
    if (!hasValidResponses) {
      determineHeight(`fs-${fieldset.id}-children`, expanded);
    }
  }, [expanded, isEditing]);

  return (
    <fieldset>
      {hasValidResponses || isEditing ? (
        <>
          <legend>{fieldset.name}</legend>
          <div>{children}</div>
        </>
      ) : (
        <>
          <legend className='empty'>
            {fieldset.name}{' '}
            {children.length > 0 && (
              <Icon
                className='right'
                icon={expanded ? 'caret-up' : 'caret-down'}
                onClick={(e) => handleClick(e)}
              />
            )}
          </legend>
          <div style={transitionStyle} id={`fs-${fieldset.id}-children`}>
            {children}
          </div>
        </>
      )}
    </fieldset>
  );
};

export default FieldsetDisplay;
